/* Converte un SVG (stringa) in PNG via canvas. Il fattore di scala è limitato
   per non superare i limiti di dimensione del canvas. */
export async function svgToPngBlob(svg: string, width: number, height: number): Promise<Blob> {
  const scale = Math.min(2, 8000 / Math.max(width, height));
  const url = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
  const img = new Image();
  await new Promise<void>((res, rej) => {
    img.onload = () => res();
    img.onerror = () => rej(new Error("SVG non caricabile per il PNG"));
    img.src = url;
  });
  const canvas = document.createElement("canvas");
  canvas.width = Math.round(width * scale);
  canvas.height = Math.round(height * scale);
  const ctx = canvas.getContext("2d")!;
  ctx.fillStyle = "#111111";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.setTransform(scale, 0, 0, scale, 0, 0);
  ctx.drawImage(img, 0, 0);
  return await new Promise<Blob>((res, rej) =>
    canvas.toBlob((b) => (b ? res(b) : rej(new Error("toBlob fallito"))), "image/png"),
  );
}
